import React from "react";
import "./modernServicesCard.css";

const ModernServicesCard = ({
  serviceCardImg,
  serviceHead,
  serviceText,
  serviceSubText,
  portalUrl,
}) => {
  return (
    <div className="modern-card">
      <div className="modern-card__image-container">
        <img
          src={serviceCardImg}
          alt={serviceHead}
          className="modern-card__image"
        />
        <div className="modern-card__overlay"></div>
      </div>

      <div className="modern-card__content">
        <div className="modern-card__header">
          <h3 className="modern-card__title">{serviceHead}</h3>
        </div>

        <div className="modern-card__body">
          <p className="modern-card__description">{serviceText}</p>
          <div className="modern-card__location">
            <svg
              className="modern-card__location-icon"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
            <span className="modern-card__address">{serviceSubText}</span>
          </div>
        </div>

        <div className="modern-card__footer">
          <button
            className="modern-card__cta"
            onClick={() => window.open(portalUrl, "_blank")}
          >
            Portal Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModernServicesCard;
